document.addEventListener('DOMContentLoaded', () => {
  console.log('USSF media JS loaded');

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const slider = gallery.querySelector('.product__media-list');
  if (!slider) return;

  const slides = slider.querySelectorAll('.slider__slide');
  if (!slides.length) return;

  const prevBtn = gallery.querySelector('.ussf-media-nav__arrow--prev');
  const nextBtn = gallery.querySelector('.ussf-media-nav__arrow--next');
  const currentEl = gallery.querySelector('.ussf-media-counter__current');
  const totalEl = gallery.querySelector('.ussf-media-counter__total');

  let currentIndex = 0;
  const total = slides.length;

  if (totalEl) totalEl.textContent = total;

  const updateUI = () => {
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === currentIndex);
    });

    if (currentEl) currentEl.textContent = currentIndex + 1;

    const target = slides[currentIndex];
    target.scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });
  };

  nextBtn?.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % total;
    updateUI();
  });

  prevBtn?.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + total) % total;
    updateUI();
  });

  // Sync when thumbnails or swipe change slides
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          currentIndex = [...slides].indexOf(entry.target);
          if (currentIndex >= 0 && currentEl) {
            currentEl.textContent = currentIndex + 1;
          }
        }
      });
    },
    {
      root: slider,
      threshold: 0.6
    }
  );

  slides.forEach(slide => observer.observe(slide));
});
